import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { HomeRegimeFailure, HomeRegimeRequest, HomeRegimeSuccess } from './actions';
import { HomeRegimeService } from './service';

@Injectable()
export class HomeRegimeEffects {
  private readonly actions$ = inject(Actions);
  private readonly homeRegimeService = inject(HomeRegimeService);

  homeRegime$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HomeRegimeRequest),
      switchMap(({ parameters }) =>
        this.homeRegimeService.homeRegime(parameters).pipe(
          map(data => HomeRegimeSuccess({ data })),
          catchError(error => of(HomeRegimeFailure({ error })))
        )
      )
    )
  );

}
